var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isExternal())?_c('a',{attrs:{"href":_vm.href,"target":_vm.target}},[_vm._t("default")],2):_c('router-link',{attrs:{"target":_vm.target,"to":_vm.href}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }